import { useEffect, useState } from 'react';
import { useGeocoder } from './useGeocoder';

export const useGeocoding = (address: string): google.maps.GeocoderResult | undefined => {
  const geocoder = useGeocoder();
  const [result, setResult] = useState<google.maps.GeocoderResult | undefined>();

  useEffect(() => {
    if (geocoder && address)
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      geocoder.geocode({ address }, function (results, status) {
        if (status == 'OK') {
          setResult(results?.at(0));
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
          // eslint-disable-next-line unicorn/no-useless-undefined
          setResult(undefined);
        }
      });
  }, [address, geocoder]);

  return result;
};
